import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { getNavSpec, type AssistantCommandView } from "@opus-dt/shared-types";
import { Button } from "@/components/ui/button";
import { confirmLeave } from "@/hooks/useNavigationGuard";

// Comando de navegação: abre a rota do NAV_REGISTRY na sessão do próprio usuário.
// Auto-navega UMA vez, e SÓ quando é o comando VIVO do turno atual (`live`) — cards de histórico
// (replay/F5) só mostram o botão, nunca arrancam o usuário para um destino antigo. O botão reabre.

export function NavigateCard({
  command,
  live = false,
}: {
  command: AssistantCommandView;
  live?: boolean;
}) {
  const navigate = useNavigate();
  const spec = getNavSpec(command.name);
  const args = (command.argsJson ?? {}) as Record<string, string>;
  const to = spec ? spec.build(args) : null;
  const screen = command.name.replace(/^nav\./, "");
  const firedRef = useRef(false);

  const go = async () => {
    if (!to) return;
    if (await confirmLeave()) navigate(to);
  };

  useEffect(() => {
    if (firedRef.current || !live || !to) return; // só o comando vivo auto-navega (uma vez)
    firedRef.current = true;
    void go();
    // eslint-disable-next-line react-hooks/exhaustive-deps -- navegação única no mount do card vivo
  }, []);

  if (!to) return null;
  return (
    <div className="rounded-md border border-border bg-background p-3 text-sm">
      <p className="mb-2 text-muted-foreground">Abrir a tela: {screen}</p>
      <Button variant="outline" size="sm" onClick={() => void go()}>
        <ArrowUpRight className="mr-1.5 h-4 w-4" aria-hidden />
        Abrir
      </Button>
    </div>
  );
}
